import { Injectable } from '@angular/core';
import { Device, SearchDevice } from 'src/app/models/device/device.model';
import { Plant, SearchPlant } from 'src/app/models/plant/plant.model';

const HISTORY_MAX_LENGTH : number = 2;
const HISTORY_STORAGE_KEY : string = 'UPService-search-history';

@Injectable()
export class LastSearchedService {

  private _searchHistory : any[] = [];

  constructor() {
    const data = JSON.parse(sessionStorage.getItem(HISTORY_STORAGE_KEY));
    if(data) this.searchHistory = data;
   }

  addDeviceToSearchHistory(device : SearchDevice){

    const searchedDev : Device = this.searchHistory.find((elem : Device) => elem.id == device.id);
    if(searchedDev) return;

    if(this.searchHistory.length == HISTORY_MAX_LENGTH) {
      this.searchHistory.splice(0, 1);
      this.searchHistory.push(device);
    }
    else this.searchHistory.push(device);
    sessionStorage.setItem(HISTORY_STORAGE_KEY, JSON.stringify(this.searchHistory));
  }

  addPlantToSearchHistory(plant : SearchPlant){

    const searchedPlant : Plant = this.searchHistory.find((elem : Plant) => elem.id == plant.id);
    if(searchedPlant) return;

    if(this.searchHistory.length == HISTORY_MAX_LENGTH) {
      this.searchHistory.splice(0, 1);
      this.searchHistory.push(plant);
    }
    else this.searchHistory.push(plant);
    sessionStorage.setItem(HISTORY_STORAGE_KEY, JSON.stringify(this.searchHistory));
  }

  get searchHistory() : any[] {
    return this._searchHistory;
  }

  set searchHistory(history : any[]) {
    this._searchHistory = history;
  }

  clearFromHistory(id : string) {

    const elem : number = this.searchHistory.findIndex((elem : Device | Plant) => elem.id == id);
    if(elem < 0) return;
    else this.searchHistory.splice(elem, 1);

    sessionStorage.setItem(HISTORY_STORAGE_KEY, JSON.stringify(this.searchHistory));
  }
}
